<template>
    <div class="container-fuild subpage-title-area">
    <div class="container">
      <div class="row">
        <div class="col-12 p-0 d-flex align-items-end overflow-hidden row m-0">
          <div class="col-12 col-sm-12 col-sm-6 col-lg-5  subpage-title p-0">
            <section>
              <h1>{{this.$store.getters.getWordLocale(pageTitle)}}</h1>
            </section>
          </div>
          <div class="col-12 col-sm-12 col-sm-6 col-lg-7  subpage-banner" :style="{
            'background-image':
              'url(' + require('/src/assets/img/subpage-banner.jpg') + ')',
          }"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ["pageTitle"],  
  methods: {
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    }    
  },
  mounted() {},
};
</script>
